import React from "react";
import TableBody from "@material-ui/core/TableBody";
import Question from "./Question";
import { IQuestionGroup } from "../surveyTypes";
import { makeStyles } from "@material-ui/core/styles";
import { Table, TableContainer, Paper } from "@material-ui/core";
import QuestionGroupHeader from "./QuestionGroupHeader";

const useGroupStyles = makeStyles((theme) => ({
  questionGroupTable: {
    tableLayout: "fixed",
    width: "100%",
  },
}));

const QuestionGroup: React.FC<IQuestionGroup> = (props: IQuestionGroup) => {
  const { indicator, questions } = props;
  const classes = useGroupStyles();
  return (
    <React.Fragment>
      <TableContainer component={Paper} elevation={0}>
        <Table className={classes.questionGroupTable}>
          <QuestionGroupHeader title={indicator.indicatorName} />
          <TableBody>
            {questions.map((question) => (
              <Question key={question.id} {...question} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default QuestionGroup;
